/** Terminals page (POS.md §18): each terminal with its open shift, for admin-dashboard and pos-web. */

export const TERMINAL_ENDPOINTS = {
  /** Staff (`terminals:list`): live rows, `?branch_id=` optional. */
  live: '/api/backoffice/terminal/live',
  /** Staff (`pos:close_shift`): ask the device to close an open shift (`:id` = shift). */
  requestClose: '/api/backoffice/terminal-shift/:id/request-close',
} as const

/** Sent by the device on every POS sync call: the terminal it is set up as, for "last synced". */
export const TERMINAL_ID_HEADER = 'X-Terminal-Id'

/** online: synced in the last 5 minutes; offline: open shift but no recent sync; idle: no open shift. */
export type TerminalSyncStatus = 'online' | 'offline' | 'idle'

export interface LiveTerminal {
  _id: string
  name: string
  unique_no: number
  status: string
  branch_id: string
  branch: { _id: string; name: string } | null
  shift: {
    _id: string
    opened_at: string
    /** `YYYY-MMDD-T<n>-S<counter>`, set by the device; null for shifts opened before numbering. */
    shift_no: string | null
    staff: { _id: string; name: string } | null
    /** Expected cash in the drawer (the shift report's `expected_cash`). */
    drawer: number
    /** Open over 12 hours. */
    long_open: boolean
    close_requested_at: string | null
  } | null
  /** Today in the store's time zone, net of returns. */
  sales_today: { total: number; orders: number }
  last_synced_at: string | null
  sync_status: TerminalSyncStatus
}
